import { render, staticRenderFns } from "./DonutChart06Template.vue?vue&type=template&id=3498e191&scoped=true"
import script from "./DonutChart06Template.vue?vue&type=script&lang=js"
export * from "./DonutChart06Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498e191",
  null
  
)

export default component.exports